import React from "react";
import { connect } from "react-redux";
import { openNotes } from "store/state/note";
import { fetchDealsStatus, downloadDeals } from "store/state/deal";
import PrefTable from "./PrefTable";

import { default as getRows } from "./GetDealRows";
import { getScreenPreferences } from "../../../shared-utility/store/state/screenPreferences";
import TablePaginationHelper from "../../../utils/tablePaginationHelper";

import SplashScreen from "../../LoadingIndicator/SplashScreen";

class DealTable extends React.Component {
  state = {
    orderDir: "asc",
    orderBy: "createdAt",
    selected: []
  };

  tablePaginationHelper = new TablePaginationHelper(this.props.tableConfigItemId, 25);

  componentDidMount() {
    this.props.fetchDealsStatus(this.props.status, {
      page: this.tablePaginationHelper.page,
      limit: this.tablePaginationHelper.rowsPerPage,
      screenType: this.props.screenType
    });
  }
  componentDidUpdate(prevProps, prevState) {
    const {screenPreferenceList} =this.props;
    const {screenPreferenceList: prevScreenPreferenceList} = prevProps;
    if(screenPreferenceList !== prevScreenPreferenceList){
      this.props.fetchDealsStatus(this.props.status, {
        page: this.tablePaginationHelper.page,
        limit: this.tablePaginationHelper.rowsPerPage,
        orderField: this.state.orderBy,
        orderDir: this.state.orderDir,
        screenType: this.props.screenType
      });
    }
  }
  // BEGIN: Table Controls
  handleRequestSort = (event, property) => {
    const orderBy = property.dataField;
    let order = "desc";
    if (orderBy) {      
      if (
        this.state.orderBy === property.dataField &&
        this.state.orderDir === "desc"
      ) {
        order = "asc";
      }

      this.setState({ orderDir: order.toLowerCase(), orderBy });
      this.tablePaginationHelper.page = 0;
      this.props.fetchDealsStatus(this.props.status, {
        page: this.tablePaginationHelper.page,
        limit: this.tablePaginationHelper.rowsPerPage,
        orderField: orderBy,
        orderDir: order,
        screenType: this.props.screenType
      });
    }
  };

  handleChangePage = (event, newPage) => {
    if (!event) {
      return null;
    }
    this.tablePaginationHelper.page = newPage;
    this.props.fetchDealsStatus(this.props.status, {
      page: this.tablePaginationHelper.page,
      limit: this.tablePaginationHelper.rowsPerPage,
      orderField: this.state.orderBy,
      orderDir: this.state.orderDir,
      screenType: this.props.screenType
    });
  };

  handleChangeRowsPerPage = event => {
    this.tablePaginationHelper.rowsPerPage = event.target.value;

    this.props.fetchDealsStatus(this.props.status, {
      page: this.tablePaginationHelper.page,
      limit: this.tablePaginationHelper.rowsPerPage,
      orderField: this.state.orderBy,
      orderDir: this.state.orderDir,
      screenType: this.props.screenType
    });
  };


  handleTableExport = () => {
    this.props.downloadDeals({ statusId: this.props.status,screenType: this.props.screenType });
  };

  render() {    
    const { screenPreferenceList, pathFunction } = this.props;
    const { dealsByStatus } = this.props.deal;
    const tableSettings = {
      tableData: dealsByStatus[this.props.status],
      dataMap: data => data.deals,
      orderDir: this.state.orderDir,
      orderBy: this.state.orderBy,
      selected: this.state.selected,
      rowsPerPage: this.tablePaginationHelper.rowsPerPage,
      page: this.tablePaginationHelper.page
    };

    const isInitializing = !dealsByStatus[this.props.status] || dealsByStatus[this.props.status].length === 0;
    
    return (
      <>
        {isInitializing && <SplashScreen loading={ isInitializing}/>}
        <PrefTable
          pathFunction={pathFunction}
          tableSettings={tableSettings}
          screenPreferences={screenPreferenceList}
          screenType={this.props.screenType}
          tableLabel={this.props.tableLabel}
          shouldHideDealExport={this.props.screenType !== "closed_deal_table"}
          handleRequestSort={this.handleRequestSort}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          TableScreenElements={this.props.TableScreenElements}
          getRows={getRows}
          exportTable={this.handleTableExport}
        />
      </>
    );
  }
}

const mapStateToProps = ({ deal, screenPreferences }, ownProps) => {
  return {
    deal,
    screenPreferenceList:
      screenPreferences.screen_pref[ownProps.screenType] || null
  };
};

export default connect(
  mapStateToProps,
  { fetchDealsStatus, openNotes, getScreenPreferences, downloadDeals }
)(DealTable);
